import ThisModule from "./ModalButtons";

export default ThisModule;
